import { Box, Typography, Link, styled } from "@mui/material";
import React from "react";
import Tooltip from "@hyro-components/Tooltip";
import useAppStore from "src/stores/appStore";
import { selectedAssistantSelector } from "src/stores/selectors/appSelectors";
import { DEFAULT_TIMEZONE, TIMEZONE_DISPLAY_NAMES } from "@consts";
import GlobeIcon from "src/icons/GlobeIcon";

const TimezoneBadge = () => {
  const selectedAssistant = useAppStore(selectedAssistantSelector);
  const timezoneKey = selectedAssistant?.timezone || DEFAULT_TIMEZONE;
  const timezoneInfo = TIMEZONE_DISPLAY_NAMES[timezoneKey];
  const timezoneDisplayName = timezoneInfo
    ? `${timezoneInfo.short} (${timezoneInfo.long})`
    : timezoneKey;

  const tooltipTitle = (
    <Typography variant="tooltip">
      All timestamps are displayed according to the agent&apos;s timezone settings.{" "}
      <StyledLink
        href="https://docs.hyro.ai/docs/date-and-time-settings#/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Learn more
      </StyledLink>
    </Typography>
  );

  if (!timezoneDisplayName) {
    return null;
  }

  return (
    <Tooltip title={tooltipTitle} tooltipStyle={{ maxWidth: "253px" }}>
      <StyledTimezoneBox>
        <GlobeIcon />
        <Typography data-testid="timezone-badge-text" variant="chip">{timezoneDisplayName}</Typography>
      </StyledTimezoneBox>
    </Tooltip>
  );
};

const StyledTimezoneBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text[700],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 1.75)
}));

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: "underline",
  cursor: "pointer",
  color: theme.palette.system[0]
}));

export default TimezoneBadge;

